import { CdkScrollable } from "@angular/cdk/scrolling";
import { Component, OnInit, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from "@angular/material/dialog";
import { Command, CommandBarComponent, LabelCommand } from "@tylertech/commands-module";
import { BusyIndicatorComponent } from "@tylertech/common-components-module";
import { IntentService } from "@tylertech/intents-module";
import { IIntent } from "@tylertech/tyler-api-types";

export interface IntentActionDialogData
{
    readonly IntentActions?: Readonly<Record<string, IIntent>>;
    readonly Title?: string;
    readonly Content?: string;
}

@Component({
    selector: "intent-action-dialog-component",
    templateUrl: "./intentActionDialog.tmpl.html",
    imports: [
        BusyIndicatorComponent,
        CdkScrollable,
        CommandBarComponent,
        MatDialogActions,
        MatDialogContent,
        MatDialogTitle,
    ]
})
export class IntentActionDialogComponent
    implements OnInit
{
    private readonly dialogRef = inject<MatDialogRef<IntentActionDialogComponent>>(MatDialogRef);
    private readonly data = inject<IntentActionDialogData>(MAT_DIALOG_DATA);
    private $intentService = inject(IntentService);

    protected resolvePromise?: Promise<void>;
    commands: ReadonlyArray<Command>;
    isProcessing: boolean;

    get title(): string { return this.friendlyName(this.data.Title); }
    get content(): string { return this.friendlyName(this.data.Content); }

    ngOnInit(): void
    {
        this.commands = this.data.IntentActions
            ? [
                new LabelCommand({
                    label: "Cancel",
                    action: () => this.close(),
                    // telemetry: "Submission-IntentActionCancel",
                }),
                ...Object.entries(this.data.IntentActions)
                    .map(([field, value]: [string, IIntent]) =>
                    {
                        return new LabelCommand({
                            label: this.friendlyName(field),
                            action: () => this.action(value),
                            // telemetry: () => `Submission-IntentAction${this.friendlyName(field)}`,
                        });
                    })
            ]
            : undefined;
    }

    private action(value: IIntent): void
    {
        this.isProcessing = true;
        this.resolvePromise = this.$intentService.resolveIntent(value)
            .then(
                r =>
                {
                    this.dialogRef.close(r);
                },
                errorResult =>
                {
                    this.dialogRef.close(
                        errorResult instanceof Error
                            ? errorResult
                            : new Error(errorResult));
                })
            .finally(() =>
            {
                this.isProcessing = false;
                this.resolvePromise = undefined;
            });
    }

    close(): void
    {
        this.dialogRef.close();
    }

    private friendlyName(name: string): string
    {
        return name.replace(/(\+)/g, " ");
    }
}
